import type { FC } from 'react';
import React from 'react';
import { IconArrowLeft } from '@alfa-bank/site-icon/arrow-left';

import { NavButton } from './nav-button';
import type { IArrow } from './models';

export const ArrowLeft: FC<IArrow> = props => {
    return (
        <NavButton {...props}>
            <IconArrowLeft height={14} width={20} />
        </NavButton>
    );
};
